import { Link } from 'react-router-dom';

export default function IconWindow({ header, icon, label, as = 'a', to, href, className = '', style }) {
  const inner = (
    <>
      {header && (
        <div className="motif-iconwin__bar">
          <span className="dot" /><span className="dot" /><span className="dot" />
          <span className="motif-iconwin__filename">{header}</span>
        </div>
      )}
      <div className="motif-iconwin__body">
        <div className="motif-iconwin__icon">{icon}</div>
        <div className="motif-iconwin__label">{label}</div>
      </div>
    </>
  );
  const cls = `motif-iconwin ${className}`.trim();
  if (as === 'link' && to) return <Link to={to} className={cls} style={style}>{inner}</Link>;
  if (href) return <a href={href} className={cls} style={style}>{inner}</a>;
  return <div className={cls} style={style}>{inner}</div>;
}
